module.exports = __webpack_public_path__ + "static/media/nav0_insta_hover.1feb99a2.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/nav0_insta_hover.png
// module id = 236
// module chunks = 0